<script>
	import { Router, Route } from "svelte-routing";
	import MainEvManagement from "./Manage/MainEVManagement.svelte";
</script>

<Router url="/">
	<Route path="/" component={MainEvManagement} />
</Router>
